import { Box, Flex, Text, Button, Heading, Card, Container } from '@radix-ui/themes';
import { useNavigate } from 'react-router-dom';

const TermsOfServicePage = () => {
    const navigate = useNavigate();

    return (
        <Flex
            direction="column"
            align="center"
            gap="9"
            py="9"
            px="4"
            style={{ minHeight: '100vh' }}
        >
            {/* Header Section */}
            <Container size="4">
                <Flex direction="column" gap="4" maxWidth="1080px">
                    <Text size="9" weight="bold" align="center">
                        Terms of Service
                    </Text>
                    <Text size="4" color="gray" align="center">
                        Effective Date: March 13, 2025
                    </Text>
                </Flex>
            </Container>

            {/* Content Section */}
            <Container size="3">
                <Flex direction="column" gap="6" width="100%" maxWidth="800px">
                    <Box>
                        <Heading size="5">1. Acceptance of Terms</Heading>
                        <Text size="3">
                            By accessing or using Dext Technology's adaptive learning platform, you agree to be bound by these Terms of Service. If you do not agree, please do not use our services.
                        </Text>
                    </Box>

                    <Box>
                        <Heading size="5">2. Use of Services</Heading>
                        <Text size="3">
                            You may use our platform for educational purposes only. You agree not to misuse our services, including but not limited to distributing malware, spamming, or engaging in illegal activities.
                        </Text>
                    </Box>

                    <Box>
                        <Heading size="5">3. Account Responsibility</Heading>
                        <Text size="3">
                            You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account. Notify us immediately of any unauthorized use.
                        </Text>
                    </Box>

                    <Box>
                        <Heading size="5">4. Intellectual Property</Heading>
                        <Text size="3">
                            All content on our platform, including quizzes, insights, and designs, is owned by Dext Technology or our licensors. You may not reproduce or distribute it without permission.
                        </Text>
                    </Box>

                    <Box>
                        <Heading size="5">5. Payment Terms</Heading>
                        <Text size="3">
                            Some features require payment. Fees are non-refundable except as required by law or specified in our refund policy. We may change pricing with prior notice.
                        </Text>
                    </Box>

                    <Box>
                        <Heading size="5">6. Termination</Heading>
                        <Text size="3">
                            We may suspend or terminate your access if you violate these terms. You may also terminate your account at any time by contacting us.
                        </Text>
                    </Box>

                    <Box>
                        <Heading size="5">7. Limitation of Liability</Heading>
                        <Text size="3">
                            Our services are provided "as is." We are not liable for indirect damages or losses arising from your use of the platform, to the extent permitted by law.
                        </Text>
                    </Box>

                    <Box>
                        <Heading size="5">8. Governing Law</Heading>
                        <Text size="3">
                            These terms are governed by the laws of Ghana. Disputes will be resolved in the courts of Kumasi, Ghana.
                        </Text>
                    </Box>

                    <Box>
                        <Heading size="5">9. Contact Us</Heading>
                        <Text size="3">
                            For questions about these Terms of Service, contact us at info@thesciencenet.com or Dext Technology, Kumasi, Ghana.
                        </Text>
                    </Box>
                </Flex>
            </Container>
        </Flex>
    );
};

export default TermsOfServicePage;